export const BRAND_URL = 'https://www.robi.com.bd/static/favicon.ico';

export const AGENT_AVATAR = 'https://cdn.mevrik.com/images/avatar-gp-bot.jpg';

export const CUSTOMER_AVATAR = '/assets/images/avatar-24.png';
